__webpack_require__.p = "/apps/beat-the-streak/game/";